import { type ReactNode } from "react";

interface Props {
  title: string;
  message: string;
  action?: ReactNode;
}

export function ErrorState({ title, message, action }: Props) {
  return (
    <div role="alert" className="flex flex-col items-center gap-3 py-16 text-center">
      <h1 className="text-lg font-semibold text-neutral-900">{title}</h1>
      <p className="max-w-sm text-sm text-neutral-500">{message}</p>
      {action}
    </div>
  );
}
